// extracted by mini-css-extract-plugin
export default {"hidden":"PrivatePolicy__hidden--I0J2b","container":"PrivatePolicy__container--h2CLF"};